import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { ConfirmationService, ConfirmEventType, MessageService, TreeNode } from 'primeng/api';
import { GlobalConstants } from '../services/global-constants';
import { PermissionHandlerService } from '../services/permission-handler.service';
import { cloneDeep } from 'lodash';
import { TranslatorPipe } from '../services/translator.pipe';
import { ExportService } from '../services/export.service';
import FileSaver from 'file-saver';
import { ContentReportExpertsService } from '../services/content-report-experts.service';

@Component({
  selector: 'app-preodic-reports',
  templateUrl: './preodic-reports.component.html',
  styleUrl: './preodic-reports.component.scss',
  providers: [ConfirmationService],
})
export class PreodicReportsComponent implements OnInit {
  createReport : boolean = false
  totalCount: number = 0;
  GlobalConstants = GlobalConstants;
  staticURL = GlobalConstants.staticFilesURL;
  treeData: any[] = [];
  selectedTreeData_orginal: any;
  selectedTreeData: any;
  selectedTreeTags_current: any;
  loading: boolean = true;
  contentUpdateUsers: any;
  //filers
  ouFilter: any;
  managerFilter: any;
  statusFilter: any;
  dateRange: any;
  report: any;
  mode: string = 'create';
  confirmationDialog: boolean = false;
  reportId: string = '';
  // Change Manager modal state
  changeManagerDialog: boolean = false;
  selectedReportForManager: any = null;
  availableManagers: any[] = [];
  selectedManager: any = null;
  /** OUs the user is assigned to as report expert. */
  expertOuIds: string[] = [];

  constructor(private dataService: DataService,  private messageService: MessageService,  private permissionService: PermissionHandlerService, private confirmationService: ConfirmationService, private exportService: ExportService, private contentReportExperts: ContentReportExpertsService) { }

  /** Admin with create rights, otherwise Manager (signer) for approvers and assigned experts. */
  private resolveMode() {
    if(this.hasPermission('PERIODIC_REPORTS','c')){
      this.mode = 'Admin';
    } else if (this.hasPermission('CONTENT_APPROVE','a') || this.expertOuIds.length > 0) {
      this.mode = 'Manager';
    }
  }

  hasPermission(key:string, flag:string) {
    return this.permissionService.hasPermission(key, flag);
  }

  async ngOnInit() {
    this.expertOuIds = this.contentReportExperts.getCachedOuIds();
    this.resolveMode();
    this.expertOuIds = await this.contentReportExperts.refreshMyOuIds();
    this.resolveMode();
    Promise.all([
      
      this.getTreeData(),
      this.fetchUsers()
    ]).then(() => {
      this.getReports().then(() => {
        this.loading = false;
        this.selectedTreeData
      });
    });
  }

  reports: any[] = [];
  currentPage: number = 1;
  rows: number = 10;    
  first: number = 0;
 
  onPageChange(event: any) {
    this.currentPage = event.first / this.rows + 1;
    this.rows = event.rows;
    this.getReports();
  }

  openCreateReportModal(){
    this.mode = 'create';
    this.createReport = true;
  }
  

  //fetch content update users
  private async fetchUsers(): Promise<void> {
    let res = await this.dataService.getData('content-update/users');
   
    if (res.error) {
      return;
    }

    this.contentUpdateUsers = res.data[0];
    this.contentUpdateUsers.approved_by = this.contentUpdateUsers.approved_by.map((user:any) => {
      const fullName = `${user.name.first} ${user.name.middle} ${user.name.last}`;
      return { ...user, name: fullName };
    });
    this.contentUpdateUsers.updated_by = this.contentUpdateUsers.updated_by.map((user:any) => {
      const fullName = `${user.name.first} ${user.name.middle} ${user.name.last}`;
      return { ...user, name: fullName };
    });

    this.contentUpdateUsers = new Set([...this.contentUpdateUsers.approved_by, ...this.contentUpdateUsers.updated_by]);

  }

  flattenTree(root: TreeNode[]): any[] {
    const result: any[] = [];
    root?.map(e => this.flattenNode(e, result))
    // this.flattenNode(root, result);
    return result;
  }

  private flattenNode(node: TreeNode, result: any[]): void {
    result.push((node as any)?._id);
    if(node?.children){
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }

  async getReports() {
    try {
      this.loading = true;
      let query = this.getFilterQuery();

      if (this.mode == 'Manager') {
        // Own OUs for approvers, plus every OU the user is assigned to as expert
        const userOUs = this.hasPermission('CONTENT_APPROVE','a') ? JSON.parse(localStorage.getItem('ou') || '[]') : [];
        query['ou'] = Array.from(new Set([...userOUs.map((ou: any) => ou._id), ...this.expertOuIds]));
      } else {
        if ((!this.ouFilter || query.ou == null) && !!this.selectedTreeData) {
          let newOuArray = this.flattenTree(this.selectedTreeData)
          query['ou'] = newOuArray;
        }
      }

      const response = await this.dataService.postData('content-update-reports/search?page='+this.currentPage+'&limit='+this.rows,query);
      if (!response.error) {
        // Handle new grouped data structure
        if (response?.data[0]?.data && Array.isArray(response.data[0].data)) {
          // Check if data is already grouped (has _id with OU info and records array)
          if (response.data[0].data[0] && response.data[0].data[0]._id && response.data[0].data[0].records) {
            this.reports = response.data[0].data;
          } else {
            // Legacy structure - group the data by OU
            this.reports = this.groupReportsByOU(response.data[0].data);
          }
        } else {
          this.reports = [];
        }
        this.totalCount = response?.data[0].totalCount[0].count;
      } else {
        console.error('No reports found', response.error);
        this.reports = [];
        this.totalCount = 0;
      }
    } catch (error) {
      // this.messageService.add({severity:'error', summary: this.translate('Error'), detail: this.translate('No reports found')});
      this.reports = [];
      this.totalCount = 0;
    } finally {
      this.loading = false;
    }
  }

  // Helper method to group reports by OU for legacy data structure
  private groupReportsByOU(reports: any[]): any[] {
    const groupedMap = new Map();
    
    reports.forEach(report => {
      const ouId = report.ou?._id;
      if (ouId) {
        if (!groupedMap.has(ouId)) {
          groupedMap.set(ouId, {
            _id: {
              _id: report.ou._id,
              name: report.ou.name,
              image: report.ou.image,
              image_sq: report.ou.image_sq
            },
            records: []
          });
        }
        groupedMap.get(ouId).records.push(report);
      }
    });
    
    return Array.from(groupedMap.values());
  }
  
  getFilterQuery() {
    let query :any  = {};
    if (this.ouFilter) {
      let newOuArray  = [this.ouFilter];
      query['ou'] =  this.flattenTree(newOuArray);
    }
    if (this.managerFilter) {
      query['manager._id'] = this.managerFilter._id;
    }
    if (this.statusFilter) {
      query['status'] = this.statusFilter.e;
    }
    if (this.dateRange) {
      query['reportFrom'] = this.dateRange[0];
      query['reportTo'] = this.dateRange[1];
    }
    return query;
  }

  closeModal(event: boolean) {
    this.createReport = false;
    this.report = null;

    this.resolveMode();

    this.getReports();
  }

  clearFilters() {
    this.ouFilter = null;
    this.managerFilter = null;
    this.statusFilter = null;
    this.dateRange = null;
    this.getReports();
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  deleteReport(reportId: string) {
    this.confirm({
      message: this.translate('Are you sure you want to cancel next report'),
      header: this.translate('Confirm message heading'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteReportAPI(reportId),
    });
  }

  async deleteReportAPI(reportId: string) {
    try {
      this.loading = true;
      let res = await this.dataService.deleteData('content-update-reports/'+reportId);
      if (!res.error) {
        this.getReports();
        this.messageService.add({severity:'success', summary: this.translate('Success'), detail: this.translate('Report cancelled successfully')});
      } else{
        this.messageService.add({severity:'error', summary: this.translate('Error'), detail: this.translate('Error deleting report')});
      }
    } catch (error) {
      console.error('Error deleting report:', error);
      this.messageService.add({severity:'error', summary: this.translate('Error'), detail: this.translate('Error cancelling report')});
    } finally { 
      this.loading = false;
    }
  }
  openReport(report: any) {
    this.report = report;
    this.createReport = true;
  }

  // Open Change Manager modal
  async openChangeManagerModal(report: any) {
    try {
      this.selectedReportForManager = report;
      this.selectedManager = null;
      this.availableManagers = [];
      this.changeManagerDialog = true;
      // Fetch managers for the OU of the selected report
      const ouId = report?.ou?._id || report?._id?._id;
      if (!ouId) {
        return;
      }
      // Only experts assigned to this OU can receive its next report
      const byOu = await this.contentReportExperts.getAssignedForReports([ouId]);
      this.availableManagers = byOu?.[ouId] || [];
    } catch (error) {
      this.availableManagers = [];
    }
  }

  // Submit Change Manager
  async submitChangeManager() {
    if (!this.selectedReportForManager || !this.selectedManager) {
      return;
    }
    try {
      this.loading = true;
      const payload = {
        _id: this.selectedReportForManager._id,
        nextManager: {
          _id: this.selectedManager._id,
          name: this.selectedManager.name,
          email: this.selectedManager.email
        }
      };

      

      const res = await this.dataService.postData('content-update-reports/' + this.selectedReportForManager._id, payload, 'PUT');
      if (!res.error) {
        this.messageService.add({severity:'success', summary: this.translate('Success'), detail: this.translate('Manager updated successfully')});
        this.changeManagerDialog = false;
        this.selectedReportForManager = null;
        this.selectedManager = null;
        this.getReports();
      } else {
        this.messageService.add({severity:'error', summary: this.translate('Error'), detail: this.translate(res?.msg || 'Failed to update manager')});
      }
    } catch (error) {
      this.messageService.add({severity:'error', summary: this.translate('Error'), detail: this.translate('Failed to update manager')});
    } finally {
      this.loading = false;
    }
  }



  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  

  async getTreeData() {
    this.treeData = await this.permissionService.extractOUChildren('CONTENT_UPDATE_LOGS', 'r');
    this.selectedTreeData_orginal = cloneDeep(this.treeData)
    this.changeSelectedTag(null);
    console.log("===>test data d",this.selectedTreeData);
  }

  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  }

  async changeSelectedTag(event: any) {
    console.log("change tag event", event);
    this.selectedTreeTags_current = {
      "label": "Ministries/Entities"
    };
    if (this.selectedTreeTags_current.label) {
      console.log("change tag event1", event,this.selectedTreeData);
      await this.filterTreeByTag("Ministries/Entities");
    } else {
      this.selectedTreeData = null;
    }
  }

  filterTreeByTag(tag: string) {
    this.selectedTreeData = cloneDeep(this.selectedTreeData_orginal);
    this.selectedTreeData = this.selectedTreeData
      .map((node: any) => this.filterNodes(node, tag))
      .filter((filteredNode: any) => filteredNode !== null);
    console.log(this.selectedTreeData);

    if (this.selectedTreeData.length == 0) {
      let cloneitems: any = []
      this.selectedTreeData_orginal.forEach((item: any) => {
        cloneitems.push({
          data: item.data,
          id: item.id,
          label: item.label,
          parent: item.parent,
          tag: item.tag,
          _id: item._id,
          children: []
        })
      });

      console.log("cloneitems.children", cloneitems);
      this.selectedTreeData = cloneDeep(cloneitems);
      console.log("cloneitems.children this.selectedTreeData", this.selectedTreeData);
    }
  }

  filterNodes(node: any, tag: string): any | null {
    if (node.children && node.children.length > 0) {
      node.children = node.children
        .map((childNode: any) => this.filterNodes(childNode, tag))
        .filter((filteredChild: any) => filteredChild !== null);
    }

    if (node.tag === tag || (node.children && node.children.length > 0)) {
      return node;
    }
    return null;
  }

  public transformReportForExport(report: any) {
    let transformedReport : any = {
      'التاريخ': report.createdAt?.substring(0,10),
      'الجهة': report.ou?.name,
      'الخبير': report.manager?.name,
      'الحالة': this.translate(report.status),
      'تاريخ البدء': report.reportFrom?.substring(0,10),
      'تاريخ الانتهاء': report.reportTo?.substring(0,10)
    };

    // Transform states array into numbered state properties
    if (report.states && Array.isArray(report.states)) {
      report.states.forEach((state: any, index: number) => {
        if(state.type && state.data.length > 0){
          transformedReport[`${this.translate(state.type)}`] = state.data.map((item:any) => item._id + '(' + item.count + ')').join(', ');
        }
        // transformedReport[`ملاحظات ${index + 1}`] = state.notes || '';
      });
    }

    return transformedReport;
  }

  async getReportStates() {
    try {
      this.loading = true;
      let query = this.getFilterQuery();
      const response = await this.dataService.postData('content-update-reports/search-without-pagination',query);
      if (!response.error) {
         return response?.data;
      } else {
        this.messageService.add({severity:'error', summary: this.translate('Error'), detail: this.translate('Error fetching reports')});
      }
    } catch (error) {
      this.reports = [];
      this.totalCount = 0;
    } finally {
      this.loading = false;
    }
  }



  public async exportExcel() {
   let reports = await this.getReportStates()
   // Flatten grouped reports for export
   let flattenedReports = this.flattenGroupedReports(reports);
   let transformedReports = flattenedReports.map((report:any) => this.transformReportForExport(report))
   this.exportService.exportContentUpdateExcel(transformedReports);
  }

  // Helper method to flatten grouped reports for export
  private flattenGroupedReports(groupedReports: any[]): any[] {
    const flattened: any[] = [];
    
    groupedReports.forEach(group => {
      if (group.records && Array.isArray(group.records)) {
        // Add OU information to each report record
        group.records.forEach((report: any) => {
          flattened.push({
            ...report,
            ou: group._id // Ensure OU info is available for each report
          });
        });
      } else {
        // Handle legacy structure
        flattened.push(group);
      }
    });
    
    return flattened;
  }

  exportContentUpdateExcel(data: Array<any>, fileName?: string) {
    let cleanedData = data;

    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(cleanedData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      if (fileName) {
        this.saveAsExcelFile(excelBuffer, fileName);
      } else {
        this.saveAsExcelFile(excelBuffer);
      }

    });
  }

  private saveAsExcelFile(buffer: any, fileName?: string): void {
    let EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    if (fileName) {
      FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    } else {
      FileSaver.saveAs(data, 'export_' + new Date().toISOString() + EXCEL_EXTENSION);
    }

  }
}
